import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgAdressbook32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M28 25H4c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h24c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1m0-17H4v16h24zM9.17 16.36C8.47 15.81 8 14.96 8 14c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .96-.46 1.81-1.17 2.36C14.68 17.09 16 18.89 16 21v.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V21c0-2.21-1.79-4-4-4s-4 1.79-4 4v.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V21c0-2.11 1.31-3.91 3.17-4.64M13 14c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m5.5-1h7c.28 0 .5.22.5.5s-.22.5-.5.5h-7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5m0 3h5c.28 0 .5.22.5.5s-.22.5-.5.5h-5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5m0 3h7c.28 0 .5.22.5.5s-.22.5-.5.5h-7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgAdressbook32);
export default Memo;